import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,

  selector: 'vs-buy-cart-delete-dialog',
  templateUrl: './cart-delete-dialog.html',
  styleUrls: ['./cart-delete-dialog.scss'],
})
export class DeleteBuyCartDialogComponent implements OnInit {
  cart: any

  /* @Input()
  cartId: any; */

  userType: any

  deleteCart
  reason: any

  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.cart = data.cart
      this.userType = data.userType
    })
    if (this.cart) {
      this.deleteCart = false
    } else {
      this.deleteCart = true
    }
  }

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      reason: reason,
      type: VS_LAUNCH_CALLER.DELETE_BUY_CART,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
